import { map } from "lodash";
import { IRelatorio, RelatorioCustodia } from "../../../models/declaracao";
import { Moment } from "moment";
import TabelaBase, {
  CelulaTexto,
  CelulaValor,
  TabelaBaseHeader,
} from "../../util/tabelas/tabelaBase";
import { useUsuario } from "../../../providers/usuarioProvider";

type Props = {
  relatorio: IRelatorio<RelatorioCustodia>;
  dataBase: Moment;
};

export default function Relatorio1({ relatorio, dataBase }: Props) {
  const { claims } = useUsuario();
  const header: TabelaBaseHeader[] = [
    {
      titulo: "Grupo",
      key: "c1",
      ordem: 1,
      align: "left",
    },
    {
      titulo: "Código",
      key: "c2",
      ordem: 2,
      align: "left",
    },
    {
      titulo: "Discriminação",
      key: "c3",
      ordem: 3,
      align: "left",
    },
    {
      titulo: `Situação em ${dataBase
        .clone()
        .subtract(1, "year")
        .endOf("year")
        .format("DD/MM/YYYY")}`,
      key: "c4",
      ordem: 4,
      align: "right",
    },
    {
      titulo: `Situação em ${dataBase
        .clone()
        .endOf("year")
        .format("DD/MM/YYYY")}`,
      key: "c5",
      ordem: 5,
      align: "right",
    },
  ];

  const rows = map(relatorio.valores, (linha, index) => ({
    c1: <CelulaTexto texto={linha.grupo || "-"} copyOnClick />,
    c2: <CelulaTexto texto={linha.codigo} copyOnClick />,
    c3: <CelulaTexto texto={linha.discriminacao} copyOnClick />,
    c4: (
      <CelulaValor
        valor={linha.situacaoInicio}
        copyOnClick
        secret={!!!claims?.stripeRole && index > 1}
      />
    ),
    c5: (
      <CelulaValor
        valor={linha.situacaoFim}
        copyOnClick
        secret={!!!claims?.stripeRole && index > 1}
      />
    ),
  }));

  return <TabelaBase header={header} rows={rows} />;
}
